export enum GritConditionType{
  Equal,
  NotEqual,
  LowerThan,
  GreaterThan,
  LowerThanEqual,
  GreaterThanEqual,
  StartsWith,
  Contains,
  Includes_Equal,
  Includes_StartsWith,
}

export class GritCondition{
  field: string;
  operator: GritConditionType;
  value: string | number;

  constructor(field: string, operator: GritConditionType, value: string | number) {
    this.field = field;
    this.operator = operator;
    this.value = value;
  }

  apply(obj: Object) : boolean{
    try{
      let objValue : any = obj;
      for (let field of this.field.split(".")){
        objValue = objValue[field];
      }

      switch (this.operator){
        case GritConditionType.Equal:
          return objValue.toString() === this.value.toString();
        case GritConditionType.NotEqual:
          return objValue.toString() !== this.value.toString();
        case GritConditionType.LowerThan:
          return objValue < this.value;
        case GritConditionType.GreaterThan:
          return objValue > this.value;
        case GritConditionType.LowerThanEqual:
          return objValue <= this.value;
        case GritConditionType.GreaterThanEqual:
          return objValue >= this.value;
        case GritConditionType.StartsWith:
          return objValue.toString().toLowerCase().startsWith(this.value.toString().toLowerCase());
        case GritConditionType.Contains:
          return objValue.toString().toLowerCase().includes(this.value.toString().toLowerCase());
        case GritConditionType.Includes_Equal:
          return (objValue as any[]).includes(this.value);
        case GritConditionType.Includes_StartsWith:
          return (objValue as any[]).find(e => e.toString().toLowerCase().startsWith(this.value.toString().toLowerCase())) != undefined;
      }

    }catch (e){
      console.error("Condition Invalid", e, this);
    }

    return false;
  }

}

export class GritFilter {
  name: string;
  conditions: GritCondition[][] = [];

  constructor(name: string = "") {
    this.name = name;
  }

  apply(obj: Object): boolean {
    let or = this.conditions.length === 0;

    for (let andConditions of this.conditions) {
      let and = true;
      for (let condition of andConditions) {
        and &&= condition.apply(obj);
        if (!and) break;
      }

      or ||= and;
      if (or) break;
    }

    return or;
  }

  fromDto(dto: GritFilter){
    this.name = dto.name;
    dto.conditions.forEach(conditionArray =>{
      let conditions = [];
      conditionArray.forEach(condition => conditions.push(new GritCondition(condition.field, condition.operator, condition.value)))
      this.conditions.push(conditions)
    })

    return this;
  }
}

